var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpperArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67323_5513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69476 1.34941C8.69458 1.3494 8.69441 1.34936 8.69422 1.34936L5.64077 1.19417C5.41202 1.18254 5.21713 1.35854 5.20549 1.58733C5.19385 1.81609 5.36986 2.01097 5.59862 2.02261L7.64868 2.12678L1.1164 7.99854C0.946049 8.15167 0.932086 8.4139 1.08522 8.58425C1.23835 8.75461 1.50057 8.76857 1.67092 8.61544L8.20319 2.74369L8.08909 4.7932C8.07637 5.0219 8.25145 5.21761 8.48015 5.23033C8.7089 5.24307 8.90458 5.06793 8.91732 4.83927L9.08727 1.7866C9.08728 1.78643 9.08726 1.78625 9.08729 1.78606C9.09971 1.5569 8.92321 1.36132 8.69476 1.34941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67323_5513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6174,
    height: 10.6174,
    fill: "white",
    transform: "translate(-2.46387 4.63477) rotate(-41.9519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperArrow);
export default __webpack_public_path__ + "static/media/UpperArrow.b835744b6c3f23774b2ff7e5108f287d.svg";
export { ForwardRef as ReactComponent };